
import React from "react";
import { Slack } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const LoadingState: React.FC = () => {
  return (
    <Card className="shadow-sm border p-6">
      <div className="flex items-center space-x-4 mb-6">
        <Slack className="h-6 w-6 text-primary" />
        <div className="flex-1">
          <Skeleton className="h-5 w-40" />
        </div>
      </div>
      <Skeleton className="h-[180px] w-full" />
    </Card>
  );
};

export default LoadingState;
